
import { useState, useEffect } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useToast } from "@/hooks/use-toast";
import { useQuery } from "convex/react";
import { api } from "../../api";

interface CategoryFilterProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

export const CategoryFilter = ({ selectedCategory, onCategoryChange }: CategoryFilterProps) => {
  const { toast } = useToast();

  // Fetch categories from Convex API
  const categoriesData = useQuery(api.appCategories.list.categories);
  
  // Transform categories data
  const categories = categoriesData ? 
    (Array.isArray(categoriesData) ? categoriesData : []).map((category: any) => ({
      _id: category._id || category.id || "",
      name: category.name || "",
      tags: category.tags || []
    })) : [];

  const isLoading = categoriesData === undefined;

  return (
    <Select value={selectedCategory} onValueChange={onCategoryChange}>
      <SelectTrigger className="w-48">
        <SelectValue placeholder={isLoading ? "Loading..." : "Filter by category"} />
      </SelectTrigger>
      <SelectContent className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 z-50">
        <SelectItem value="all">All Categories</SelectItem>
        {categories.map((category) => (
          <SelectItem key={category._id} value={category.name}>
            {category.name}
          </SelectItem>
        ))}
        {categories.length === 0 && !isLoading && (
          <SelectItem value="no-categories" disabled>
            No categories found
          </SelectItem>
        )}
      </SelectContent>
    </Select>
  );
};
